import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {

                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PU_00006',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
            layers: {
                active: true,
                title: 'layers.title',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PU_00002',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PU_00007',
                },
            },
            regulations: {
                active: true,
                title: 'Regulamentos',
                label: 'Regulamentos',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PU_00028',
                },
                url: {
                    getData: `${codeAPI}/front/regulations`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [
                        {
                            'id': 'addr',
                            'name': 'navsearch.address.title',
                            'url': '../gateway/address/search',
                            'listGroup': 'adminName1',
                            'labelTemplate': 'navsearch.address.labelTemplate',
                            'subLabelTemplate': null,
                            'placeholder': 'navsearch.address.placeholder'
                        },
                        {
                            'id': 'pu-urbanism',
                            'name': 'Urbanismo',
                            'url': `${codeAPI}/search/urbanism`,
                            'labelTemplate': '${label}',
                            'listTemplate': '${name}',
                            'listGroup': 'type',
                            'placeholder': 'Urbanismo...',
                        },
                        {
                            'id': 'pu-epl',
                            'name': 'Plantas Localização',
                            'url': `${codeAPI}/search/epl`,
                            'labelTemplate': '${label}',
                            'listTemplate': '${name}',
                            'listGroup': 'type',
                            'placeholder': 'Planta Localização...',
                        }
                    ],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            catalog: {
                acl: {
                    view: 'PU_00011',
                },
            },
            identify: {
                acl: {
                    view: 'PU_00012',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PU_00010',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            searchAllotment: {
                active: true,
                title: "Alvarás de Loteamentos",
                label: "Filtros",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    allowExportData: true,
                    formatExportData: 'xls',
                    preserveGeometry: true,
                },
                acl: {
                    view: 'PU_00004',
                },
                url: {
                    searchAll: `${codeAPI}/allotments/search`,
                    getLists: `${codeAPI}/allotments/search/lists`,
                    getSubTypes: `${codeAPI}/allotments/subtypes/:type`,
                    export: `${codeAPI}/allotments/search/export`,
                    job: `${codeAPI}/allotments/search/export/job/:id`,
                },
            },
            allotment: {
                active: true,
                title: 'Alvará de Loteamento',
                panel: {
                    show: false,
                    loaded: false,
                    upload: {
                        acceptTypes: [
                            'application/vnd.ms-powerpoint',
                            'application/mspowerpoint',
                            'application/vnd.ms-excel',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'application/msword',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            'application/msword',
                            'application/vnd.ms-word.template.macroEnabled.12',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
                            'application/pdf',
                            'image/jpeg',
                            'image/bmp',
                            'image/x-png',
                            'image/png',
                            'image/gif',
                            'image/svg+xml',
                            'text/plain',
                            'text/csv',
                            'text/tab-separated-values',
                            'image/tiff',
                            'image/x-tiff',
                            'application/dxf',
                            'application/acad',
                            'application/x-dxf',
                            'application/x-acad',
                            'application/x-autocad',
                            'application/dwf',
                            'model/vnd-dwf',
                            'model/vnd.dwfx+xps',
                            'drawing/x-dxf',
                            'image/vnd.dxf',
                            'image/x-autocad',
                            'image/x-dxf',
                            'application/autocad_dwg',
                            'image/x-dwg',
                            'application/dwg',
                            'application/x-dwg',
                            'application/x-autocad',
                            'image/vnd.dwg',
                            'drawing/dwg',
                            'application/vnd.shp',
                            'application/x-mif',
                            'application/dgn',
                            'image/vnd.dgn',
                            'image/ecw',
                            'image/sid',
                            '.dwg',
                            '.dwf',
                            '.dwfx',
                            '.dxf',
                            '.shp',
                            '.mif',
                            '.dgn',
                            '.ecw',
                            '.sid',
                        ],
                    },
                    statuses: [
                        {
                            id: 1,
                            fields: {
                                allowed: ['*'],
                            }
                        },
                        {
                            id: 2,
                            fields: {
                                allowed: ['status_id'],
                            }
                        },
                        {
                            id: 3,
                            fields: {
                                allowed: ['status_id'],
                            }
                        }
                    ],
                },
                acl: {
                    view: 'PU_00080',
                    add: 'PU_00081',
                    export: 'PU_00085',
                    audit: 'PU_00100',
                },
                url: {
                    show: `${codeAPI}/allotments/data/:license`,
                    export: `${codeAPI}/allotments/export/:id`,
                    create: `${codeAPI}/allotments`,
                    update: `${codeAPI}/allotments/:id`,
                    delete: `${codeAPI}/allotments/:id`,
                    getLists: `${codeAPI}/allotments/lists/:license`,
                    audit: `${codeAPI}/allotments/history/:id`,
                },
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
                layers: {
                    features: {
                        scale: .5,
                        scaleSelected: 1,
                    },
                },
                interactions: {
                    draw: {
                    },
                },
            }
        },
        config: {

        },
    },
};

export default state;